// // src/libs/services/article.ts
// import { publicClient, apiClient } from './axiosInstance';
// import { pickDefined, ensureOk, toFormData } from '../helpers/api-helper';
// import { normalizeArticle, normalizeMessageList } from '@/libs/transform/article-transform';
// import { EmojiItem, ArticleAllThingResult, ArticleCreateResponse } from '@/types/article';
// import type { Article, ArticleMessage, ArticleTable, ArticleTypeRaw } from '@/model/article';

// /** 後端外層包裝（兼容 status / code 命名） */
// export type ApiEnvelope<T = unknown, E = unknown> = {
//   status?: number;
//   code?: number;
//   message: string;
//   data?: T;
//   errors?: E | null;
// };

// // 放在上面工具區也可以抽成共用 helper
// function normalizeTableId(table: string, tableId: string | number): string | number {
//   if (typeof tableId === 'number') return tableId;

//   const trimmed = String(tableId).trim();

//   // 支援像 "collection_682"、"store_article_123" 這種 slug
//   const parts = trimmed.split('_');
//   if (parts.length > 1 && parts[0] === table) {
//     const last = parts[parts.length - 1];
//     // 如果最後一段是數字就用它，否則就原樣回傳
//     return /^\d+$/.test(last) ? last : trimmed;
//   }

//   return trimmed;
// }

// /* -------------------------------------------------------
//  * message_get_coin_data raw 型別（list / detail 共用）
//  * ----------------------------------------------------- */

// export type MessageGetCoinDataRaw = {
//   name: string;
//   Photo: string;
//   type: string; // kol / tcoin / womo ...
// };

// /* -------------------------------------------------------
//  * chip_give_data raw 型別（list / detail 共用）
//  * ----------------------------------------------------- */

// export type ChipGiveDataRaw = {
//   amount?: number | string;
//   crtime?: string;
//   ex_amount?: number | string;
//   id?: number | string;
//   is_active?: number | string;
//   letime?: string;
//   quantity?: number | string;
//   type?: string; // kol / tcoin / womo ...
//   type_id?: number | string;
//   type_name?: string;
//   type_photo?: string;
//   user_id?: number | string;
// };

// /* -------------------------------------------------------
//  * 文章清單 GET /article
//  * -----------------------------------------------------*/

// export type ArticleListParams = {
//   /** 分頁（必填） */
//   page: number | string;
//   /** kol_id（非必填） */
//   kol_id?: number | string;
//   womo_id?: string | number;
//   /** 店家 store_id（非必填） */
//   store_id?: number | string;
//   ar_store_id?: number | string;
//   /** 是否 AR 貼文（非必填：0 非 AR，1 AR；不填＝全部） */
//   is_ar?: 0 | 1;
//   /** 貼文類型 privilege_kol / collection / store_article / kol_privilege_article（非必填） */
//   table?: string;
// };

// /** 後端回傳格式（未 normalize 的單筆文章） */
// export type ArticleListItem = {
//   // 主鍵 + 類型
//   table_id: number | string;
//   table: string;
//   table_code?: number;

//   // 分類
//   article_type?: ArticleTypeRaw;
//   article_time_out?: number;

//   // 時間相關
//   ai_show_time?: string;
//   create_time?: string;
//   crtime?: string;
//   update_time?: string;

//   // AR / 店家 / branch
//   ar_type?: 'ar_space' | 'branch' | '' | null;
//   ar_space_id?: string | number | '' | null;
//   ar_is_active?: string | number | 0 | 1 | '' | null;
//   branch_address?: string;
//   branch_name?: string;

//   //AR空間資訊
//   ar_store_id?: number | string;
//   ar_branch_name: string;
//   ar_title: string;

//   // 券 / 特權相關
//   coin_start_date?: string;
//   coin_end_date?: string;
//   flash_reward_coin_id?: number;
//   privilege_id?: number;
//   kol_privilege_id?: number;

//   // 內容 / 圖片 / 媒體
//   type?: 'img' | 'url' | 'music' | 'text' | 'short' | string;
//   type_id?: number | string;
//   cover?: string;
//   photo?: string | null;
//   photo_data?: string[];
//   depiction?: string;
//   url?: string;
//   tiktok_id?: string;
//   music?: string;
//   music_name?: string;
//   shortData?:
//     | string
//     | {
//         cover?: string;
//         crtime?: string;
//         key?: string;
//         ledtime?: string;
//         short_id?: string;
//         user_id?: string;
//         video_url?: string;
//       }[]
//     | null; //本機上傳影片

//   // emoji
//   emoji_id?: number;
//   emoji_photo?: string;

//   // 作者 / KOL
//   kol_id?: number;
//   kol_name?: string | null;
//   womo_id?: string | null;
//   kol_photo?: string | null;
//   kol_u_photo?: string | null;

//   // 店家
//   store_id?: number;
//   store_name?: string | null;
//   store_open_id?: string | null;
//   store_photo?: string | null;
//   store_photo_small?: string | null;
//   store_photo_thumbnail?: string | null;

//   // 統計數字
//   look_num?: number;
//   share_num?: number;
//   favorite_num?: number;
//   message_num?: number;
//   praise_num?: number;
//   receive_num?: number;
//   heat_num?: number;

//   // 狀態 / flag 類
//   is_active?: number;
//   is_ai?: number;
//   is_ar?: number;
//   is_certified?: number;
//   is_discuss?: number;
//   is_edit?: boolean;
//   is_exchange?: number;
//   is_privilege?: number;
//   is_report?: number;
//   is_secret?: number;
//   is_store_show?: number;
//   is_warn?: number;
//   is_youtube_group?: number;
// };

// /* -------------------------------------------------------
//  * 單篇文章 GET /article/{table}/{id}
//  * -----------------------------------------------------*/

// export type ArticleDetailParams = {
//   table: string;
//   table_id: string | number;
// };

// /** 單篇的 data item（沿用 list 的欄位再加幾個） */
// export type ArticleDetailData = ArticleListItem & {
//   praise_num?: number;
//   message_num?: number;
//   is_fav?: boolean;
//   is_praise?: boolean;
//   message?: ArticleMessageItem[];
// };

// /**
//  * 單篇文章 API 的 data 內容
//  * （實際後端目前仍為 { article_data, user_permission } 結構）
//  */
// export type ArticleDetailResult = {
//   article_data: ArticleDetailData;
//   user_permission?: {
//     user_id: number;
//     user_name: string;
//     user_u_photo: string;
//     user_photo: string;
//   }[];
// };

// /* -------------------------------------------------------
//  * 留言 /article/message
//  * -----------------------------------------------------*/

// export type ArticleMessageParams = {
//   /** 分頁（必填） */
//   page: number | string;
//   /** table（必填） privilege_kol / collection / store_article / kol_privilege_article */
//   table: string;
//   /** table_id（必填） */
//   table_id: string | number;
//   /** is_parent 非必填：1 只顯示非回覆；0 或不填：所有 */
//   is_parent?: 0 | 1;
//   /** message_reply_id 非必填：顯示特定回覆留言 */
//   message_reply_id?: number;
// };

// export type ArticleMessageItem = {
//   id: string;
//   parent_id: string;
//   user_id: string;
//   original_user_id?: string;
//   content: string;
//   child_num: string;
//   reward_num?: string;
//   is_super?: boolean;
//   is_active?: boolean;
//   is_edit?: boolean;
//   update_time?: string;
//   create_time?: string;

//   // 留言者相關資訊（API 有帶的話就會填）
//   kol_id?: number | string;
//   womo_id?: string | null;
//   kol_name?: string | null;
//   kol_u_photo?: string | null;
//   kol_photo?: string | null;

//   user_name?: string | null;
//   user_u_photo?: string | null;
//   user_photo?: string | null;
// };

// export type ArticleMessageResult = {
//   total: number;
//   data: ArticleMessageItem[];
// };

// /* -------------------------------------------------------
//  * 新增留言後回傳的「獲得籌碼」資訊（/article/message POST）
//  * ----------------------------------------------------- */

// // 後端原始 item 結構（對應 swagger 的 data.items）
// // type ArticleCreateMessageRawItem = {
// //   message_get_coin_data?: {
// //     type?: string; // tcoin, kol, kol_pay, womo ...
// //     user_id?: string;
// //     name?: string;
// //     photo?: string;
// //     u_photo?: string;
// //   }[];
// //   chip_give_data?: {
// //     id?: string;
// //     type?: string; // tcoin, kol, kol_pay, womo ...
// //     coin_id?: string;
// //     coin_name?: string;
// //     coin_photo?: string;
// //     amount?: string; // 數量，後端用 string
// //   }[];
// // };

// // 後端實際回傳的 data 是 array
// // type ArticleCreateMessageRaw = ArticleCreateMessageRawItem[];

// // 前端整理後的型別（方便使用）
// export type MessageGetCoinInfo = {
//   type: string; // tcoin / kol / kol_pay / womo ...
//   userId: string;
//   name: string;
//   photo: string;
//   uPhoto: string;
// };

// export type ChipGiveInfo = {
//   id: string;
//   type: string; // tcoin / kol / kol_pay / womo ...
//   coinId: string;
//   coinName: string;
//   coinPhoto: string;
//   amount: number; // 已轉成 number
// };

// /**
//  * createMessage 回傳的「本次留言獲得籌碼」資訊
//  * - chipGiveList：chip_give 類型的贈幣
//  * - messageGetCoinList：message_get_coin 類型的贈幣
//  */
// export type CreateMessageReward = {
//   messageGetCoinList: MessageGetCoinInfo[];
//   chipGiveList: ChipGiveInfo[];
// };

// /* -------------------------------------------------------
//  * 分享 +1 /article/share
//  * -----------------------------------------------------*/

// export type ArticleSharePayload = {
//   table: string;
//   table_id: number | string;
// };

// /* -------------------------------------------------------
//  * Article Service（主要對外提供的 API）
//  * -----------------------------------------------------*/

// type ErrorWithResponse = {
//   response?: {
//     status?: number;
//     data?: unknown;
//   };
// };

// function hasResponse(e: unknown): e is ErrorWithResponse {
//   return typeof e === 'object' && e !== null && 'response' in e;
// }

// export type ArticleFavItem = {
//   is_fav: boolean;
//   num: number;
// };

// export const ArticleService = {
//   /**
//    * 文章列表
//    * GET /article
//    *
//    * Query：
//    * - page     (必填)
//    * - kol_id   (非必填)
//    * - store_id (非必填)
//    * - is_ar    (非必填 0/1)
//    * - table    (非必填)
//    *
//    * 回傳已整理過的 Article[]
//    */
//   async list(params: ArticleListParams): Promise<Article[]> {
//     const query = pickDefined({
//       page: params.page,
//       kol_id: params.kol_id,
//       womo_id: params.womo_id,
//       store_id: params.store_id,
//       ar_store_id: params.ar_store_id,
//       is_ar: params.is_ar,
//       table: params.table,
//     });

//     // 🌟 新版：改成 GET + querystring
//     const res = await publicClient.get<ApiEnvelope<ArticleListItem[]>>('/article', {
//       params: query,
//     });

//     console.log('[ArticleService.list] raw response:', res.data);

//     const payload = ensureOk<ArticleListItem[] | Record<string, unknown>>(res.data);

//     // 新版文件是 array；為了保險，如果後端還是 object，就兜成陣列
//     let list: ArticleListItem[];
//     if (Array.isArray(payload)) {
//       list = payload;
//     } else {
//       list = Object.values(payload).filter((item): item is ArticleListItem => {
//         return !!item && typeof item === 'object' && 'table_id' in item;
//       });
//     }

//     const normalized = list.map((item) => normalizeArticle(item));

//     console.log('[ArticleService.list] normalized articles:', normalized);

//     return normalized;
//   },

//   /**
//    * 單篇文章
//    * GET /article/{table}/{id}
//    * 回傳格式化後的 Article
//    */
//   async detail(params: ArticleDetailParams): Promise<Article> {
//     const { table, table_id } = params;

//     const safeTable = String(table).trim();
//     const safeTableId =
//       typeof table_id === 'number' || typeof table_id === 'string' ? String(table_id).trim() : '';

//     if (!safeTable || !safeTableId) {
//       console.error('[ArticleService.detail] invalid params:', params);
//       throw new Error('缺少 table 或 table_id，無法取得文章');
//     }

//     const url = `/article/${encodeURIComponent(safeTable)}/${encodeURIComponent(safeTableId)}`;

//     console.log('[ArticleService.detail] request url:', url, 'params:', params);

//     try {
//       const res = await publicClient.get<ApiEnvelope<ArticleDetailResult>>(url);

//       console.log('[ArticleService.detail] raw response:', res.data);

//       const raw = ensureOk<ArticleDetailResult>(res.data);

//       // ✅ 真正的文章在 raw.article_data 裡
//       if (!raw || !raw.article_data) {
//         console.error('[ArticleService.detail] empty or invalid article_data field:', raw);
//         throw new Error('文章不存在或 API 回傳空資料');
//       }

//       const base = raw.article_data;

//       // ✅ 把 user_permission[0] 合併進來，讓 normalizeArticle 能從 user_* 欄位取作者資訊
//       const firstPerm = raw.user_permission?.[0];

//       const merged: ArticleDetailData & {
//         user_name?: string;
//         user_u_photo?: string;
//         user_photo?: string;
//         user_id?: number;
//       } = {
//         ...base,
//       };

//       if (firstPerm) {
//         // 若 article_data 本身沒有 kol_*，就用 user_* 當作者 fallback
//         if (!merged.user_name) merged.user_name = firstPerm.user_name;
//         if (!merged.user_u_photo) merged.user_u_photo = firstPerm.user_u_photo;
//         if (!merged.user_photo) merged.user_photo = firstPerm.user_photo;
//         if (merged.user_id == null) merged.user_id = firstPerm.user_id;
//       }

//       console.log('[ArticleService.detail] merged article_data for normalize:', merged);

//       const article = normalizeArticle(merged);

//       // ⭐⭐ 關鍵：強制用「呼叫 detail 時的 table / table_id」覆蓋
//       // 這樣前端的 article.table / article.id 就會跟留言 API 用的完全一致
//       (article as Article).table = safeTable as Article['table'];
//       (article as Article).id = `${safeTable}_${safeTableId}`;

//       // 若後端有回傳 message，順便整理掛在 article 上
//       if (base.message) {
//         article.messages = normalizeMessageList(base.message);
//       }

//       console.log('[ArticleService.detail] normalized article:', article);

//       return article;
//     } catch (err: unknown) {
//       if (hasResponse(err) && err.response) {
//         console.error(
//           '[ArticleService.detail] axios-like error:',
//           'status =',
//           err.response.status,
//           'data =',
//           err.response.data
//         );
//       } else {
//         console.error('[ArticleService.detail] error (no response):', err);
//       }
//       throw err;
//     }
//   },

//   /**
//    * 取得文章留言列表
//    * GET /article/message/{table}/{id}
//    *
//    * Path：
//    * - table    （必填）
//    * - id       （必填，對應 table_id）
//    *
//    * Query：
//    * - page             （必填）
//    * - is_parent        （非必填 0/1）
//    * - message_reply_id （非必填）
//    *
//    * 回傳前端格式：{ total, list: ArticleMessage[] }
//    */
//   async message(params: ArticleMessageParams): Promise<{ total: number; list: ArticleMessage[] }> {
//     const { table, table_id, page, is_parent, message_reply_id } = params;

//     const safeTable = String(table).trim();
//     const safeTableId = normalizeTableId(safeTable, table_id);

//     if (!safeTable || !safeTableId) {
//       console.error('[ArticleService.message] invalid params:', params);
//       throw new Error('缺少 table 或 table_id，無法取得留言');
//     }

//     const url = `/article/message/${encodeURIComponent(safeTable)}/${encodeURIComponent(
//       String(safeTableId)
//     )}`;

//     const query = pickDefined({
//       page,
//       is_parent,
//       message_reply_id,
//     });

//     // 需要登入（bearerAuth），所以用 apiClient
//     const res = await apiClient.get<ApiEnvelope<ArticleMessageResult>>(url, {
//       params: query,
//     });

//     const raw = ensureOk<ArticleMessageResult>(res.data);

//     const messages = normalizeMessageList(raw.data);

//     // console.log(
//     //   '[ArticleService.message] url:',
//     //   url,
//     //   'query:',
//     //   query,
//     //   'messages:',
//     //   messages,
//     //   'total:',
//     //   raw.total
//     // );

//     return {
//       total: raw.total ?? messages.length,
//       list: messages,
//     };
//   },

//   /**
//    * 新增 / 送出留言
//    * POST /article/message
//    *
//    * 參考文件：
//    *  - table           必填：privilege_kol / collection / store_article / kol_privilege_article
//    *  - table_id        必填：對應文章 id（後端現在多半只吃純數字 id）
//    *  - content         必填：留言內容
//    *  - parent_id       非必填：要回覆哪一則留言（留言 id）
//    *  - user_id         非必填：若有切身分發言
//    *  - message_get_coin 非必填：1 表示送籌碼（collection 才有）
//    *  - chip_give_id    非必填：贈送籌碼 id（collection 才有）
//    *
//    * 回傳：
//    *  - CreateMessageReward：本次留言實際獲得的籌碼資訊（若沒有則為空陣列）
//    */
//   async createMessage(payload: {
//     table: string;
//     table_id: string | number;
//     content: string;
//     parent_id?: string | number;
//     user_id?: string | number;
//     message_get_coin?: 0 | 1;
//     chip_give_id?: string | number;
//   }): Promise<CreateMessageReward> {
//     const safeTable = String(payload.table).trim();
//     const safeTableId = normalizeTableId(safeTable, payload.table_id);
//     const safeContent = (payload.content ?? '').trim();

//     if (!safeTable || !safeTableId) {
//       console.error('[ArticleService.createMessage] invalid table/table_id:', payload);
//       throw new Error('缺少 table 或 table_id，無法送出留言');
//     }

//     if (!safeContent) {
//       console.error('[ArticleService.createMessage] empty content:', payload);
//       throw new Error('留言內容不可為空');
//     }

//     const form = toFormData(
//       pickDefined({
//         table: safeTable,
//         table_id: safeTableId,
//         content: safeContent,
//         parent_id: payload.parent_id,
//         user_id: payload.user_id,
//         message_get_coin: payload.message_get_coin,
//         chip_give_id: payload.chip_give_id,
//       })
//     );

//     try {
//       // ⚠️ 這裡不要假設 data 型別，一律先用 unknown 接
//       const res = await apiClient.post<ApiEnvelope<unknown>>('/article/message', form);

//       //console.log('[ArticleService.createMessage] raw envelope:', res.data);

//       // 先用 ensureOk 取出 data（可能是留言物件，也可能是 reward 結構）
//       const raw = ensureOk<unknown>(res.data);

//       // ---------------------------------------
//       // 1) 找看看 response 裡面有沒有 reward 結構
//       //    - message_get_coin_data: array?
//       //    - chip_give_data: array?
//       //    如果都沒有，就直接回空 reward
//       // ---------------------------------------
//       let first: any = null;

//       if (Array.isArray(raw)) {
//         // 若 data 是陣列，找第一個有 reward 欄位的
//         for (const item of raw) {
//           if (
//             item &&
//             typeof item === 'object' &&
//             ('message_get_coin_data' in item || 'chip_give_data' in item)
//           ) {
//             first = item;
//             break;
//           }
//         }
//       } else if (raw && typeof raw === 'object') {
//         // 若 data 是單一物件，且本身就帶有 reward 欄位
//         const obj = raw as any;
//         if ('message_get_coin_data' in obj || 'chip_give_data' in obj) {
//           first = obj;
//         }
//       }

//       // 🎯 沒有 reward 結構 → 表示這次只是純新增留言，不要再 .map()，直接給空陣列
//       if (!first) {
//         const emptyReward: CreateMessageReward = {
//           messageGetCoinList: [],
//           chipGiveList: [],
//         };

//         // console.log(
//         //   '[ArticleService.createMessage] no reward data in response, return empty reward. payload:',
//         //   { ...payload, table: safeTable, table_id: safeTableId }
//         // );

//         return emptyReward;
//       }

//       // ---------------------------------------
//       // 2) 安全地從 first 取出 message_get_coin_data / chip_give_data
//       //    只在「真的是 array」的情況下才 map
//       // ---------------------------------------
//       const rawMsgCoin = Array.isArray((first as any).message_get_coin_data)
//         ? ((first as any).message_get_coin_data as any[])
//         : [];

//       const rawChipGive = Array.isArray((first as any).chip_give_data)
//         ? ((first as any).chip_give_data as any[])
//         : [];

//       const messageGetCoinList: MessageGetCoinInfo[] = rawMsgCoin.map((d) => ({
//         type: d.type ?? '',
//         userId: d.user_id ?? '',
//         name: d.name ?? '',
//         photo: d.photo ?? '',
//         uPhoto: d.u_photo ?? '',
//       }));

//       const chipGiveList: ChipGiveInfo[] = rawChipGive.map((d) => ({
//         id: d.id ?? '',
//         type: d.type ?? '',
//         coinId: d.coin_id ?? '',
//         coinName: d.coin_name ?? '',
//         coinPhoto: d.coin_photo ?? '',
//         amount: Number(d.amount ?? '0') || 0,
//       }));

//       const reward: CreateMessageReward = {
//         messageGetCoinList,
//         chipGiveList,
//       };

//       // console.log(
//       //   '[ArticleService.createMessage] success for payload:',
//       //   { ...payload, table: safeTable, table_id: safeTableId },
//       //   'reward:',
//       //   reward
//       // );

//       return reward;
//     } catch (err: unknown) {
//       if (hasResponse(err) && err.response) {
//         console.error(
//           '[ArticleService.createMessage] axios-like error:',
//           'status =',
//           err.response.status,
//           'data =',
//           err.response.data
//         );
//       } else {
//         console.error('[ArticleService.createMessage] error (no response):', err);
//       }
//       throw err;
//     }
//   },

//   /**
//    * 刪除留言（實際上是 is_active = 0）
//    * DELETE /article/message/{table}/{id}
//    *
//    * - table: privilege_kol / collection / store_article / kol_privilege_article
//    * - id   : 該留言 id
//    */
//   async deleteMessage(table: string, id: string | number): Promise<void> {
//     const safeTable = String(table).trim();
//     const safeId = typeof id === 'number' || typeof id === 'string' ? String(id).trim() : '';

//     if (!safeTable || !safeId) {
//       console.error('[ArticleService.deleteMessage] invalid params:', { table, id });
//       throw new Error('缺少 table 或 id，無法刪除留言');
//     }

//     const url = `/article/message/${encodeURIComponent(safeTable)}/${encodeURIComponent(safeId)}`;

//     const res = await apiClient.delete<ApiEnvelope<unknown>>(url);

//     ensureOk(res.data);
//     //console.log('[ArticleService.deleteMessage] success for', { table: safeTable, id: safeId });
//   },

//   /**
//    * 刪除文章（目前僅支援 table = 'collection'）
//    * DELETE /article/collection/{id}
//    */
//   async deleteArticle(params: { table: ArticleTable; table_id: string | number }): Promise<void> {
//     const safeTable = String(params.table).trim();
//     const safeId =
//       typeof params.table_id === 'number' || typeof params.table_id === 'string'
//         ? String(params.table_id).trim()
//         : '';

//     if (!safeId) {
//       console.error('[ArticleService.deleteArticle] invalid params:', params);
//       throw new Error('缺少文章 ID，無法刪除文章');
//     }

//     if (safeTable !== 'collection') {
//       console.error('[ArticleService.deleteArticle] unsupported table:', safeTable, params);
//       throw new Error('目前僅支援刪除心情貼文（collection）');
//     }

//     const url = `/article/collection/${encodeURIComponent(safeId)}`;

//     const res = await apiClient.delete<ApiEnvelope<unknown>>(url);

//     ensureOk(res.data);
//     //console.log('[ArticleService.deleteArticle] success for', params);
//   },

//   /**
//    * 文章蒐藏 / 取消蒐藏
//    * GET /article/fav
//    *
//    * - table    : privilege_kol / collection / store_article / kol_privilege_article
//    * - table_id : 對應文章 id
//    *
//    * 回傳：{ isFav, num }
//    */
//   async fav(params: { table: string; table_id: string | number }): Promise<{
//     isFav: boolean;
//     num: number;
//   }> {
//     const safeTable = String(params.table).trim();
//     const safeTableId = String(params.table_id).trim();

//     // 檢查 table 和 table_id 是否有值
//     if (!safeTable || !safeTableId) {
//       //console.error('[ArticleService.fav] Invalid params:', params);
//       throw new Error('收藏文章時缺少 table 或 table_id 參數');
//     }

//     const res = await apiClient.get<ApiEnvelope<ArticleFavItem[] | ArticleFavItem>>(
//       '/article/fav',
//       {
//         params: {
//           table: safeTable,
//           table_id: safeTableId,
//         },
//       }
//     );

//     //console.log('[ArticleService.fav] raw response:', res.data);

//     const payload = ensureOk<ArticleFavItem[] | ArticleFavItem>(res.data);

//     const list: ArticleFavItem[] = Array.isArray(payload) ? payload : [payload];

//     const first = list[0] ?? { is_fav: false, num: 0 };

//     return {
//       isFav: !!first.is_fav,
//       num: typeof first.num === 'number' ? first.num : 0,
//     };
//   },

//   /**
//    * 分享 +1
//    * GET /article/share
//    *
//    * Query:
//    * - table    : privilege_kol / collection / store_article / kol_privilege_article
//    * - table_id : 對應文章 id
//    */
//   async share(payload: ArticleSharePayload): Promise<void> {
//     const params = pickDefined({
//       table: payload.table,
//       table_id: payload.table_id,
//     });

//     const res = await apiClient.get<ApiEnvelope<unknown>>('/article/share', {
//       params,
//     });

//     ensureOk(res.data);
//     //console.log('[ArticleService.share] success for payload:', payload);
//   },

//   /*皇冠使用*/
//   // 取得Emoji
//   async getEmoji() {
//     const { data } = await publicClient.get<ApiEnvelope<EmojiItem[]>>('/emoji');
//     const result = ensureOk<EmojiItem[]>(data);
//     return result;
//   },

//   // 新增貼文
//   async addNewPost(payload: FormData) {
//     const { data } = await apiClient.post<ApiEnvelope<ArticleCreateResponse>>(
//       '/article/insert',
//       payload
//     );
//     const result = ensureOk<ArticleCreateResponse>(data);
//     return result;
//   },

//   // 修改貼文
//   async updatePost(payload: FormData) {
//     await apiClient.post<ApiEnvelope>('/article/update', payload);
//     return;
//   },

//   // 取得單一貼文
//   async getUnitPost(params: { table: string; table_id: string | number }) {
//     const { table, table_id } = params;

//     const url = `/article/${encodeURIComponent(table)}/${encodeURIComponent(table_id)}`;

//     const { data } = await apiClient.get<ApiEnvelope<ArticleAllThingResult>>(url);
//     const result = ensureOk<ArticleAllThingResult>(data);

//     return result.article_data;
//   },
// };

// src/libs/services/article.ts
import { publicClient, apiClient } from './axiosInstance';
import { pickDefined, ensureOk, toFormData } from '../helpers/api-helper';
import { normalizeArticle, normalizeMessageList } from '@/libs/transform/article-transform';
import { EmojiItem, ArticleAllThingResult, GetCoinBonus } from '@/types/article';
import type { Article, ArticleMessage, ArticleTable, ArticleTypeRaw } from '@/model/article';

/** 後端外層包裝（兼容 status / code 命名） */
export type ApiEnvelope<T = unknown, E = unknown> = {
  status?: number;
  code?: number;
  message: string;
  data?: T;
  errors?: E | null;
};

// 放在上面工具區也可以抽成共用 helper
function normalizeTableId(table: string, tableId: string | number): string | number {
  if (typeof tableId === 'number') return tableId;

  const trimmed = String(tableId).trim();

  // 支援像 "collection_682"、"store_article_123" 這種 slug
  const parts = trimmed.split('_');
  if (parts.length > 1 && parts[0] === table) {
    const last = parts[parts.length - 1];
    // 如果最後一段是數字就用它，否則就原樣回傳
    return /^\d+$/.test(last) ? last : trimmed;
  }

  return trimmed;
}

/* -------------------------------------------------------
 * message_get_coin_data raw 型別（list / detail 共用）
 * ----------------------------------------------------- */

export type MessageGetCoinDataRaw = {
  name: string;
  Photo: string;
  type: string; // kol / tcoin / womo ...
};

/* -------------------------------------------------------
 * chip_give_data raw 型別（list / detail 共用）
 * ----------------------------------------------------- */

export type ChipGiveDataRaw = {
  amount?: number | string;
  crtime?: string;
  ex_amount?: number | string;
  id?: number | string;
  is_active?: number | string;
  letime?: string;
  quantity?: number | string;
  type?: string; // kol / tcoin / womo ...
  type_id?: number | string;
  type_name?: string;
  type_photo?: string;
  user_id?: number | string;
};

/* -------------------------------------------------------
 * 文章清單 GET /article
 * -----------------------------------------------------*/

export type ArticleListParams = {
  /** 分頁（必填） */
  page: number | string;
  /** kol_id（非必填） */
  kol_id?: number | string;
  womo_id?: string | number;
  /** 店家 store_id（非必填） */
  store_id?: number | string;
  ar_store_id?: number | string;
  /** 是否 AR 貼文（非必填：0 非 AR，1 AR；不填＝全部） */
  is_ar?: 0 | 1;
  /** 貼文類型 privilege_kol / collection / store_article / kol_privilege_article（非必填） */
  table?: string;
};

/** 後端回傳格式（未 normalize 的單筆文章） */
export type ArticleListItem = {
  // 主鍵 + 類型
  table_id: number | string;
  table: string;
  table_code?: number;

  // 分類
  article_type?: ArticleTypeRaw;
  article_time_out?: number;

  // 時間相關
  ai_show_time?: string;
  create_time?: string;
  crtime?: string;
  update_time?: string;

  // AR / 店家 / branch（舊欄位）
  ar_type?: 'ar_space' | 'branch' | '' | null;
  ar_space_id?: string | number | '' | null;
  ar_is_active?: string | number | 0 | 1 | '' | null;
  branch_address?: string;
  branch_name?: string;

  //AR空間資訊（舊欄位）
  ar_store_id?: number | string;
  ar_branch_name: string;
  ar_title: string;

  // 券 / 特權相關
  coin_start_date?: string;
  coin_end_date?: string;
  flash_reward_coin_id?: number;
  privilege_id?: number;
  kol_privilege_id?: number;

  // 內容 / 圖片 / 媒體
  type?: 'img' | 'url' | 'music' | 'text' | 'short' | string;
  type_id?: number | string;
  cover?: string;
  photo?: string | null;
  photo_data?: string[];
  depiction?: string;
  url?: string;
  tiktok_id?: string;
  music?: string;
  music_name?: string;
  shortData?:
    | string
    | {
        cover?: string;
        crtime?: string;
        key?: string;
        ledtime?: string;
        short_id?: string;
        user_id?: string;
        video_url?: string;
      }[]
    | null; //本機上傳影片

  // emoji
  emoji_id?: number;
  emoji_photo?: string;

  // 作者 / KOL
  kol_id?: number;
  kol_name?: string | null;
  womo_id?: string | null;
  kol_photo?: string | null;
  kol_u_photo?: string | null;

  // 店家
  store_id?: number;
  store_name?: string | null;
  store_open_id?: string | null;
  store_photo?: string | null;
  store_photo_small?: string | null;
  store_photo_thumbnail?: string | null;

  // 統計數字
  look_num?: number;
  share_num?: number;
  favorite_num?: number;
  message_num?: number;
  praise_num?: number;
  receive_num?: number;
  heat_num?: number;

  // 狀態 / flag 類
  is_active?: number;
  is_ai?: number;
  is_ar?: number;
  is_certified?: number;
  is_discuss?: number;
  is_edit?: boolean;
  is_exchange?: number;
  is_privilege?: number;
  is_report?: number;
  is_secret?: number;
  is_store_show?: number;
  is_warn?: number;
  is_youtube_group?: number;
};

/* -------------------------------------------------------
 * 單篇文章 GET /article/{table}/{id}
 * -----------------------------------------------------*/

export type ArticleDetailParams = {
  table: string;
  table_id: string | number;
};

/** 單篇的 data item（沿用 list 的欄位再加幾個） */
export type ArticleDetailData = ArticleListItem & {
  praise_num?: number;
  message_num?: number;
  is_fav?: boolean;
  is_praise?: boolean;
  message?: ArticleMessageItem[];

  // ✅ 注意：後端現在還會回 camelCase 的 AR 欄位
  // 這些欄位不一定每次都有，所以用 optional
  arBranchName?: string | null;
  arSpaceId?: string | number | null;
  arSpaceType?: 'branch' | 'ar_space' | string | null;
  arStoreId?: string | number | null;
  arTitle?: string | null;
};

/**
 * 單篇文章 API 的 data 內容
 * （實際後端目前仍為 { article_data, user_permission } 結構）
 */
export type ArticleDetailResult = {
  article_data: ArticleDetailData;
  user_permission?: {
    user_id: number;
    user_name: string;
    user_u_photo: string;
    user_photo: string;
  }[];
};

/* -------------------------------------------------------
 * 留言 /article/message
 * -----------------------------------------------------*/

export type ArticleMessageParams = {
  /** 分頁（必填） */
  page: number | string;
  /** table（必填） privilege_kol / collection / store_article / kol_privilege_article */
  table: string;
  /** table_id（必填） */
  table_id: string | number;
  /** is_parent 非必填：1 只顯示非回覆；0 或不填：所有 */
  is_parent?: 0 | 1;
  /** message_reply_id 非必填：顯示特定回覆留言 */
  message_reply_id?: number;
};

export type ArticleMessageItem = {
  id: string;
  parent_id: string;
  user_id: string;
  original_user_id?: string;
  content: string;
  child_num: string;
  reward_num?: string;
  is_super?: boolean;
  is_active?: boolean;
  is_edit?: boolean;
  update_time?: string;
  create_time?: string;

  // 留言者相關資訊（API 有帶的話就會填）
  kol_id?: number | string;
  womo_id?: string | null;
  kol_name?: string | null;
  kol_u_photo?: string | null;
  kol_photo?: string | null;

  user_name?: string | null;
  user_u_photo?: string | null;
  user_photo?: string | null;
};

export type ArticleMessageResult = {
  total: number;
  data: ArticleMessageItem[];
};

/* -------------------------------------------------------
 * 新增留言後回傳的「獲得籌碼」資訊（/article/message POST）
 * ----------------------------------------------------- */

export type MessageGetCoinInfo = {
  type: string; // tcoin / kol / kol_pay / womo ...
  userId: string;
  name: string;
  photo: string;
  uPhoto: string;
};

export type ChipGiveInfo = {
  id: string;
  type: string; // tcoin / kol / kol_pay / womo ...
  coinId: string;
  coinName: string;
  coinPhoto: string;
  amount: number; // 已轉成 number
};

export type CreateMessageReward = {
  messageGetCoinList: MessageGetCoinInfo[];
  chipGiveList: ChipGiveInfo[];
};

/* -------------------------------------------------------
 * 分享 +1 /article/share
 * -----------------------------------------------------*/

export type ArticleSharePayload = {
  table: string;
  table_id: number | string;
};

/* -------------------------------------------------------
 * Article Service（主要對外提供的 API）
 * -----------------------------------------------------*/

type ErrorWithResponse = {
  response?: {
    status?: number;
    data?: unknown;
  };
};

function hasResponse(e: unknown): e is ErrorWithResponse {
  return typeof e === 'object' && e !== null && 'response' in e;
}

export type ArticleFavItem = {
  is_fav: boolean;
  num: number;
};

export const ArticleService = {
  /**
   * 文章列表
   * GET /article
   */
  async list(params: ArticleListParams): Promise<Article[]> {
    const query = pickDefined({
      page: params.page,
      kol_id: params.kol_id,
      womo_id: params.womo_id,
      store_id: params.store_id,
      ar_store_id: params.ar_store_id,
      is_ar: params.is_ar,
      table: params.table,
    });

    const res = await publicClient.get<ApiEnvelope<ArticleListItem[]>>('/article', {
      params: query,
    });

    //console.log('[ArticleService.list] raw response:', res.data);

    const payload = ensureOk<ArticleListItem[] | Record<string, unknown>>(res.data);

    let list: ArticleListItem[];
    if (Array.isArray(payload)) {
      list = payload;
    } else {
      list = Object.values(payload).filter((item): item is ArticleListItem => {
        return !!item && typeof item === 'object' && 'table_id' in item;
      });
    }

    const normalized = list.map((item) => normalizeArticle(item));
    //console.log('[ArticleService.list] normalized articles:', normalized);

    return normalized;
  },

  /**
   * 單篇文章
   * GET /article/{table}/{id}
   * 回傳格式化後的 Article
   *
   * ✅ 支援 table_id 傳入 "collection_944" 這種 slug
   */
  async detail(params: ArticleDetailParams): Promise<Article> {
    const { table, table_id } = params;

    const safeTable = String(table).trim();
    const safeTableId = normalizeTableId(safeTable, table_id);

    if (!safeTable || safeTableId === '' || safeTableId === null || safeTableId === undefined) {
      console.error('[ArticleService.detail] invalid params:', params);
      throw new Error('缺少 table 或 table_id，無法取得文章');
    }

    const url = `/article/${encodeURIComponent(safeTable)}/${encodeURIComponent(String(safeTableId))}`;

    //console.log('[ArticleService.detail] request url:', url, 'params:', params);

    try {
      const res = await publicClient.get<ApiEnvelope<ArticleDetailResult>>(url);

      //console.log('[ArticleService.detail] raw response:', res.data);

      const raw = ensureOk<ArticleDetailResult>(res.data);

      if (!raw || !raw.article_data) {
        console.error('[ArticleService.detail] empty or invalid article_data field:', raw);
        throw new Error('文章不存在或 API 回傳空資料');
      }

      const base = raw.article_data;

      // 把 user_permission[0] 合併進來，讓 normalizeArticle 能從 user_* 欄位取作者資訊
      const firstPerm = raw.user_permission?.[0];

      const merged: ArticleDetailData & {
        user_name?: string;
        user_u_photo?: string;
        user_photo?: string;
        user_id?: number;
      } = {
        ...base,
      };

      if (firstPerm) {
        if (!merged.user_name) merged.user_name = firstPerm.user_name;
        if (!merged.user_u_photo) merged.user_u_photo = firstPerm.user_u_photo;
        if (!merged.user_photo) merged.user_photo = firstPerm.user_photo;
        if (merged.user_id == null) merged.user_id = firstPerm.user_id;
      }

      //console.log('[ArticleService.detail] merged article_data for normalize:', merged);

      const article = normalizeArticle(merged);

      // 強制用「呼叫 detail 時的 table / table_id」覆蓋（與留言 API 一致）
      (article as Article).table = safeTable as Article['table'];
      (article as Article).id = `${safeTable}_${String(safeTableId)}`;

      if (base.message) {
        article.messages = normalizeMessageList(base.message);
      }

      //console.log('[ArticleService.detail] normalized article:', article);

      return article;
    } catch (err: unknown) {
      if (hasResponse(err) && err.response) {
        console.error(
          '[ArticleService.detail] axios-like error:',
          'status =',
          err.response.status,
          'data =',
          err.response.data
        );
      } else {
        console.error('[ArticleService.detail] error (no response):', err);
      }
      throw err;
    }
  },

  /**
   * 取得文章留言列表
   * GET /article/message/{table}/{id}
   */
  async message(params: ArticleMessageParams): Promise<{ total: number; list: ArticleMessage[] }> {
    const { table, table_id, page, is_parent, message_reply_id } = params;

    const safeTable = String(table).trim();
    const safeTableId = normalizeTableId(safeTable, table_id);

    if (!safeTable || safeTableId === '' || safeTableId === null || safeTableId === undefined) {
      console.error('[ArticleService.message] invalid params:', params);
      throw new Error('缺少 table 或 table_id，無法取得留言');
    }

    const url = `/article/message/${encodeURIComponent(safeTable)}/${encodeURIComponent(
      String(safeTableId)
    )}`;

    const query = pickDefined({
      page,
      is_parent,
      message_reply_id,
    });

    const res = await apiClient.get<ApiEnvelope<ArticleMessageResult>>(url, {
      params: query,
    });

    const raw = ensureOk<ArticleMessageResult>(res.data);
    const messages = normalizeMessageList(raw.data);

    return {
      total: raw.total ?? messages.length,
      list: messages,
    };
  },

  /**
   * 新增 / 送出留言
   * POST /article/message
   */
  async createMessage(payload: {
    table: string;
    table_id: string | number;
    content: string;
    parent_id?: string | number;
    user_id?: string | number;
    message_get_coin?: 0 | 1;
    chip_give_id?: string | number;
  }): Promise<CreateMessageReward> {
    const safeTable = String(payload.table).trim();
    const safeTableId = normalizeTableId(safeTable, payload.table_id);
    const safeContent = (payload.content ?? '').trim();

    if (!safeTable || safeTableId === '' || safeTableId === null || safeTableId === undefined) {
      console.error('[ArticleService.createMessage] invalid table/table_id:', payload);
      throw new Error('缺少 table 或 table_id，無法送出留言');
    }

    if (!safeContent) {
      console.error('[ArticleService.createMessage] empty content:', payload);
      throw new Error('留言內容不可為空');
    }

    const form = toFormData(
      pickDefined({
        table: safeTable,
        table_id: safeTableId,
        content: safeContent,
        parent_id: payload.parent_id,
        user_id: payload.user_id,
        message_get_coin: payload.message_get_coin,
        chip_give_id: payload.chip_give_id,
      })
    );

    try {
      const res = await apiClient.post<ApiEnvelope<unknown>>('/article/message', form);
      const raw = ensureOk<unknown>(res.data);

      let first: any = null;

      if (Array.isArray(raw)) {
        for (const item of raw) {
          if (
            item &&
            typeof item === 'object' &&
            ('message_get_coin_data' in item || 'chip_give_data' in item)
          ) {
            first = item;
            break;
          }
        }
      } else if (raw && typeof raw === 'object') {
        const obj = raw as any;
        if ('message_get_coin_data' in obj || 'chip_give_data' in obj) {
          first = obj;
        }
      }

      if (!first) {
        return {
          messageGetCoinList: [],
          chipGiveList: [],
        };
      }

      const rawMsgCoin = Array.isArray((first as any).message_get_coin_data)
        ? ((first as any).message_get_coin_data as any[])
        : [];

      const rawChipGive = Array.isArray((first as any).chip_give_data)
        ? ((first as any).chip_give_data as any[])
        : [];

      const messageGetCoinList: MessageGetCoinInfo[] = rawMsgCoin.map((d) => ({
        type: d.type ?? '',
        userId: d.user_id ?? '',
        name: d.name ?? '',
        photo: d.photo ?? '',
        uPhoto: d.u_photo ?? '',
      }));

      const chipGiveList: ChipGiveInfo[] = rawChipGive.map((d) => ({
        id: d.id ?? '',
        type: d.type ?? '',
        coinId: d.coin_id ?? '',
        coinName: d.coin_name ?? '',
        coinPhoto: d.coin_photo ?? '',
        amount: Number(d.amount ?? '0') || 0,
      }));

      return {
        messageGetCoinList,
        chipGiveList,
      };
    } catch (err: unknown) {
      if (hasResponse(err) && err.response) {
        console.error(
          '[ArticleService.createMessage] axios-like error:',
          'status =',
          err.response.status,
          'data =',
          err.response.data
        );
      } else {
        console.error('[ArticleService.createMessage] error (no response):', err);
      }
      throw err;
    }
  },

  /**
   * 刪除留言（實際上 is_active = 0）
   * DELETE /article/message/{table}/{id}
   */
  async deleteMessage(table: string, id: string | number): Promise<void> {
    const safeTable = String(table).trim();
    const safeId = typeof id === 'number' || typeof id === 'string' ? String(id).trim() : '';

    if (!safeTable || !safeId) {
      console.error('[ArticleService.deleteMessage] invalid params:', { table, id });
      throw new Error('缺少 table 或 id，無法刪除留言');
    }

    const url = `/article/message/${encodeURIComponent(safeTable)}/${encodeURIComponent(safeId)}`;
    const res = await apiClient.delete<ApiEnvelope<unknown>>(url);

    ensureOk(res.data);
  },

  /**
   * 刪除文章（目前僅支援 table = 'collection'）
   * DELETE /article/collection/{id}
   */
  async deleteArticle(params: { table: ArticleTable; table_id: string | number }): Promise<void> {
    const safeTable = String(params.table).trim();
    const safeId =
      typeof params.table_id === 'number' || typeof params.table_id === 'string'
        ? String(params.table_id).trim()
        : '';

    if (!safeId) {
      console.error('[ArticleService.deleteArticle] invalid params:', params);
      throw new Error('缺少文章 ID，無法刪除文章');
    }

    if (safeTable !== 'collection') {
      console.error('[ArticleService.deleteArticle] unsupported table:', safeTable, params);
      throw new Error('目前僅支援刪除心情貼文（collection）');
    }

    const url = `/article/collection/${encodeURIComponent(safeId)}`;
    const res = await apiClient.delete<ApiEnvelope<unknown>>(url);

    ensureOk(res.data);
  },

  /**
   * 文章蒐藏 / 取消蒐藏
   * GET /article/fav
   *
   * ✅ 支援 table_id 傳入 "collection_944" 這種 slug
   */
  async fav(params: { table: string; table_id: string | number }): Promise<{
    isFav: boolean;
    num: number;
  }> {
    const safeTable = String(params.table).trim();
    const safeTableId = normalizeTableId(safeTable, params.table_id);

    if (!safeTable || safeTableId === '' || safeTableId === null || safeTableId === undefined) {
      throw new Error('收藏文章時缺少 table 或 table_id 參數');
    }

    const res = await apiClient.get<ApiEnvelope<ArticleFavItem[] | ArticleFavItem>>(
      '/article/fav',
      {
        params: {
          table: safeTable,
          table_id: String(safeTableId),
        },
      }
    );

    const payload = ensureOk<ArticleFavItem[] | ArticleFavItem>(res.data);
    const list: ArticleFavItem[] = Array.isArray(payload) ? payload : [payload];

    const first = list[0] ?? { is_fav: false, num: 0 };

    return {
      isFav: !!first.is_fav,
      num: typeof first.num === 'number' ? first.num : 0,
    };
  },

  /**
   * 分享 +1
   * GET /article/share
   *
   * ✅ 支援 table_id 傳入 "collection_944" 這種 slug
   */
  async share(payload: ArticleSharePayload): Promise<void> {
    const safeTable = String(payload.table).trim();
    const safeTableId = normalizeTableId(safeTable, payload.table_id);

    const params = pickDefined({
      table: safeTable,
      table_id: safeTableId,
    });

    const res = await apiClient.get<ApiEnvelope<unknown>>('/article/share', {
      params,
    });

    ensureOk(res.data);
  },

  /* 皇冠使用 */

  async getEmoji() {
    const { data } = await publicClient.get<ApiEnvelope<EmojiItem[]>>('/emoji');
    const result = ensureOk<EmojiItem[]>(data);
    return result;
  },

  async addNewPost(payload: FormData) {
    const { data } = await apiClient.post<ApiEnvelope<GetCoinBonus>>('/article/insert', payload);
    console.log(data);
    const result = ensureOk<GetCoinBonus>(data);

    return result;
  },

  async updatePost(payload: FormData) {
    await apiClient.post<ApiEnvelope>('/article/update', payload);
    return;
  },

  /**
   * 取得單一貼文（原本的 admin/舊流程）
   * ✅ 也一起支援 slug，避免未來踩雷
   */
  async getUnitPost(params: { table: string; table_id: string | number }) {
    const safeTable = String(params.table).trim();
    const safeTableId = normalizeTableId(safeTable, params.table_id);

    const url = `/article/${encodeURIComponent(safeTable)}/${encodeURIComponent(String(safeTableId))}`;

    const { data } = await apiClient.get<ApiEnvelope<ArticleAllThingResult>>(url);
    const result = ensureOk<ArticleAllThingResult>(data);

    return result.article_data;
  },
};
